import React from 'react';
import { Formik, Form } from 'formik';

import { ReactComponent as Plus } from 'svg/plus.svg';

import Circle from 'components/circle';
import { Page } from 'components/layouts';
import Connection from 'components/connection';
import Button from 'components/button';
import Field, { FieldTextArea } from 'components/field';

import './style.css';

const Contact = () => {
  return (
    <Page className="page -contact">
      <Connection
        A={{ query: '.text-area-control', pivot: { x: 0.1, y: 1 } }}
        B={{ query: '.plus-icon' }}
        duration={6}
        curve={0.5}
      />
      <Connection
        A={{ query: '.button[type="submit"]', pivot: { x: 1, y: 0.5 } }}
        B={{ query: '.plus-icon' }}
        duration={3}
      />
      <Connection
        A={{ query: 'label[for=name]', pivot: { x: 0, y: 0.5 } }}
        B={{ query: '.target.-t01' }}
        duration={4}
        curve={0.2}
      />
      <Connection
        A={{ query: 'label[for=name]', pivot: { x: 0, y: 0.5 } }}
        B={{ query: '.target.-t02' }}
        duration={4}
        curve={0.2}
      />
      <section className="contact-form">
        <Circle
          className="contact-circle"
          width="400px"
          angle={320}
          distance={16}
          blur={32}
        />
        <div className="target -t01" />
        <div className="target -t02" />
        <div className="contact-form-wrapper">
          <h3 className="contact-form-title">
            Let’s get connected so we can begin the process of <br />
            Tweaking your business together.
          </h3>
          <Formik
            initialValues={{
              name: '',
              email: '',
              message: '',
            }}
            onSubmit={async (values) => {
              await new Promise((r) => setTimeout(r, 500));
              console.info(JSON.stringify(values, null, 2));
            }}
          >
            <Form>
              <Field
                id="name"
                label="Name"
                name="name"
                placeholder="Your name"
                orientation="horizontal"
              />

              <Field
                label="Email"
                id="email"
                name="email"
                placeholder="your@email.com"
                type="email"
                orientation="horizontal"
              />

              <FieldTextArea
                looks="input"
                label="Message"
                id="message"
                name="message"
                placeholder="Hello"
                orientation="horizontal"
                rows={8}
              />

              <footer>
                <Button type="submit" hierarchy="tertiary">
                  Send
                </Button>
                <Plus className="plus-icon" />
              </footer>
            </Form>
          </Formik>
        </div>
      </section>
    </Page>
  );
};

export default Contact;
